import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import ReferenceCard from '../references/ReferenceCard';

/**
 * SortableReferenceCard - Wrapper for sortable reference cards
 * Used with @dnd-kit for drag-and-drop reference reordering
 */
function SortableReferenceCard(props) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: props.reference.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div ref={setNodeRef} style={style}>
      <ReferenceCard {...props} dragHandleProps={{ ...attributes, ...listeners }} />
    </div>
  );
}

export default SortableReferenceCard;
